// Inclina el contenido en 3D siguiendo el puntero (solo con mouse o lápiz).
const Tilt = ({ children, className = "", max = 10, ...rest }) => {

    const handleMove = (e) => {
        if (e.pointerType === "touch") return;
        const el = e.currentTarget;
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.setProperty("--lp-tilt-x", (-y * max).toFixed(2) + "deg");
        el.style.setProperty("--lp-tilt-y", (x * max).toFixed(2) + "deg");
        el.style.setProperty("--lp-glare-x", ((x + 0.5) * 100).toFixed(0) + "%");
        el.style.setProperty("--lp-glare-y", ((y + 0.5) * 100).toFixed(0) + "%");
    }

    const handleLeave = (e) => {
        const el = e.currentTarget;
        el.style.setProperty("--lp-tilt-x", "0deg");
        el.style.setProperty("--lp-tilt-y", "0deg");
    }

  return (
    <div className={"lp-tilt " + className} onPointerMove={handleMove} onPointerLeave={handleLeave} {...rest}>
        {children}
    </div>
  )
}

export default Tilt
